/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取文慧卷列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  cultureCouponId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.OrderTicketCouponDetail>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/culture-coupons/${cultureCouponId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
